<template>
  <a href="https://www.patreon.com/carlbot/membership" target="_blank">
    <b-button
      class="premium-cta patreon-btn"
      size="lg"
      @click="trackPremiumCTA"
    >
      <img
        src="/img/brand/patreon-symbol-white.svg"
        alt="Patreon"
        class="cta-svg-icon mr-2"
      />
      Buy on Patreon
    </b-button>
  </a>
</template>

<script>
export default {
  name: "PatreonPremiumButton",
  methods: {
    trackPremiumCTA() {
      this.$emit("track", "patreon");
    }
  }
};
</script>

<style scoped>
.premium-cta {
  font-size: 1.3rem;
  font-weight: bold;
  padding: 0.7rem 2.2rem;
  border-radius: 2rem;
  display: inline-flex;
  align-items: center;
  gap: 0.5em;
}
.cta-svg-icon {
  height: 1.5em;
  width: 1.5em;
  vertical-align: middle;
  margin-bottom: 2px;
}
.patreon-btn {
  background-color: #111 !important;
  color: #fff !important;
  border: 2px solid #111 !important;
  box-shadow: 0 2px 12px rgba(124, 92, 255, 0.15);
  font-weight: 600;
}
.patreon-btn:hover {
  background-color: #fff !important;
  color: #111 !important;
  border: 2px solid #fff !important;
}

.patreon-btn .cta-svg-icon {
  filter: brightness(0) invert(1);
}
.patreon-btn:hover .cta-svg-icon {
  filter: none;
}

@media (max-width: 767.98px) {
  .premium-cta {
    font-size: 1rem;
    padding: 0.6rem 1.2rem;
  }
}
</style>
